export default "__VITE_ASSET__BYPy4bhL__"